import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import Groups3OutlinedIcon from '@mui/icons-material/Groups3Outlined';
import ViewInArOutlinedIcon from '@mui/icons-material/ViewInArOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';

// The permissions.js key for this page — canAccessNav / canFeature are keyed by route.
export const USER_ANALYTICS_ROUTE = '/user-analytics';

// The design's exact hexes (Global Admin User Analytics.html). Kept local on purpose: the
// app shell uses #072146 / #0a326d, and only this page's content follows the design.
export const analyticsUiTokens = {
  navy: '#0d2b57',
  darkNavy: '#081d3d',
  activeNav: '#1c4278',
  green: '#16a34a',
  orange: '#c25e00',
  purple: '#7c3aed',
  teal: '#0891b2',
  cardBorder: '#e2e8f0',
  slate: {
    50: '#f8fafc', 100: '#f1f5f9', 200: '#e2e8f0', 300: '#cbd5e1', 400: '#94a3b8',
    500: '#64748b', 600: '#475569', 700: '#334155', 800: '#1e293b',
  },
  sky: { 50: '#f0f9ff', 100: '#e0f2fe', 200: '#bae6fd', 300: '#7dd3fc', 600: '#0284c7', 700: '#0369a1', 800: '#075985' },
  emerald: { 50: '#ecfdf5', 600: '#059669', 700: '#047857' },
  indigo: { 50: '#eef2ff', 100: '#e0e7ff', 600: '#4f46e5', 800: '#3730a3' },
  purpleSoft: { 100: '#f3e8ff', 800: '#6b21a8' },
  amber: { 50: '#fffbeb', 200: '#fde68a', 600: '#d97706', 700: '#b45309' },
  orangeSoft: { 50: '#fff7ed', 200: '#fed7aa' },
  red: { 50: '#fef2f2', 200: '#fecaca', 700: '#b91c1c' },
};

export const DEFAULT_PERIOD = '30d';

// Raw UI state. `emailDomain` is what the input shows; it is normalised + debounced before it
// reaches a request. `from`/`to` only matter while period === 'custom'.
export const DEFAULT_FILTERS = Object.freeze({
  entityId: null,
  spaceId: null,
  emailDomain: '',
  period: DEFAULT_PERIOD,
  from: '',
  to: '',
});

export const DATE_PERIODS = [
  { value: 'today', label: 'Today', badge: 'Today' },
  { value: '7d', label: '7D', badge: 'Last 7 Days' },
  { value: '14d', label: '14D', badge: 'Last 14 Days' },
  { value: '30d', label: '30D', badge: 'Last 30 Days' },
  { value: '90d', label: '90D', badge: 'Last 90 Days' },
  { value: 'custom', label: 'Custom', badge: 'Custom' },
];

export const MAX_RANGE_DAYS = 366;
export const DEBOUNCE_MS = 300;

export const PAGE_SIZES = [10, 25, 50];
export const DEFAULT_PAGE_SIZE = 10;
export const SEARCH_MAX_LENGTH = 100;

// Fixed start of the popup's activity period (backend plan D8); the end is "today" in ET.
export const ACTIVITY_DEFAULT_FROM = '2026-08-28';

export const CARD_KEYS = {
  TOTAL: 'total',
  DAU: 'dau',
  WAU: 'wau',
  MAU: 'mau',
  IMMERSIVE: 'immersive',
  CMS: 'cms',
};

export const CARDS = {
  total: { label: 'Total Users', modalTitle: 'Total Users Directory', Icon: GroupsOutlinedIcon },
  dau: { label: 'Daily Active (DAU)', modalTitle: 'Daily Active Users (DAU)', Icon: HowToRegOutlinedIcon },
  wau: { label: 'Weekly Active (WAU)', modalTitle: 'Weekly Active Users (WAU)', Icon: PeopleAltOutlinedIcon },
  mau: { label: 'Monthly Active (MAU)', modalTitle: 'Monthly Active Users (MAU)', Icon: Groups3OutlinedIcon },
  immersive: { label: 'Total Immersive Users', modalTitle: 'Total Immersive Users (3D / VR Spaces)', Icon: ViewInArOutlinedIcon },
  cms: { label: 'Total CMS Users', modalTitle: 'Total CMS Users (CMS Portal)', Icon: TuneOutlinedIcon },
};

// Lists that can contain CMS-only accounts (no session rows, so no login history).
export const CARDS_WITH_CMS_ONLY_USERS = [CARD_KEYS.TOTAL, CARD_KEYS.CMS];

export const CMS_NO_LOGIN_HINT =
  'CMS accounts have no login history — for CMS-only users First Login is the account creation time '
  + 'and Last Login, Total Sessions and Total Active Days show "—".';

export const NO_ACCESS_MESSAGE = "You don't have access to analytics for this space.";
